import React from 'react';
import Linkify from 'react-linkify';

const renderLink = ({ href, text, key, underlineStyle }) => (
  <a
    href={href}
    rel="noopener noreferrer"
    style={underlineStyle ? { pointerEvents: 'all', textDecoration: 'underline' } : { pointerEvents: 'all' }}
    target="_blank"
    key={key}
  >
    {text}
  </a>
);

const MyLinkify = ({ children, underlineStyle }) => {
  return (
    <Linkify componentDecorator={(href, text, key) => renderLink({ href, text, key, underlineStyle })}>
      {children}
    </Linkify>
  );
};
export default MyLinkify;
